<template>
  <div
    :class="['modal-background', {'modal-background-show': show, 'cursor-pointer': clickOut}]"
    @click="clickOut ? close() : ''"
  >
    <div
      id="ex1"
      :class="['modal', {'modal-show': show}]"
      @click="stop"
    >
      <div class="conteudo-modal">
        <h3 class="titulo-modal">{{titulo}}
        </h3>
        <div
          v-html="conteudo"
          v-if="conteudo"
        ></div>
        <img
          :src="imagem"
          alt=""
          v-if="imagem"
          class="imagem-modal"
        />
      </div>
      <a
        rel="modal:close"
        class="close-modal icon-remove"
        @click="close"
      >
        X
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    clickOut: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: '',
    },
    conteudo: {
      type: String,
      default: '',
    },
    imagem: {
      type: String,
      default: '',
    },
  },
  methods: {
    stop(event) {
      event.stopPropagation();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
